<app-page-header
  [pageTitle]="'Establecimientos'"
  [showCreateButton]="false"
/>

<app-filters-container
  [hasData]="establecimientos.length > 0"
  [hasActiveFilters]="hasActiveFilters"
  [loading]="loading"
  (clearFilters)="clearFilters()"
>
  <app-search-input
    label="Buscar"
    placeholder="Buscar por establecimiento, cliente o dirección..."
    [value]="searchTerm"
    (searchChange)="onSearchChange($event)"
  />

  <app-filter-select
    label="Objetivo"
    [value]="selectedObjetivo"
    [options]="objetivosOptions"
    (valueChange)="onObjetivoChange($event)"
  />

  <app-filter-select
    label="Zona"
    [value]="selectedZona"
    [options]="zonasOptions"
    [containerClass]="'min-w-[260px]'"
    (valueChange)="onZonaChange($event)"
  />
</app-filters-container>

<app-data-table
  [columns]="columns"
  [data]="establecimientos"
  [loading]="loading"
  [clickableRows]="false"
  [emptyTitle]="'No hay establecimientos registrados'"
  [emptySubtitle]="'Prueba ajustando los filtros'"
>
  <ng-template appTableCell="cliente_nombre" let-establecimiento>
    @if (establecimiento.cliente_nombre) {
      {{ establecimiento.cliente_nombre }}
    } @else {
      <span class="text-gray-400 dark:text-gray-500">-</span>
    }
  </ng-template>

  <ng-template appTableCell="objetivo" let-establecimiento>
    @let objetivoBadge = getObjetivoBadge(establecimiento.objetivo);
    <app-badge [color]="objetivoBadge.color" [variant]="objetivoBadge.variant || 'light'">
      {{ objetivoBadge.label }}
    </app-badge>
  </ng-template>

  <ng-template appTableCell="direccion" let-establecimiento>
    @if (establecimiento.direccion) {
      <div class="flex flex-col">
        {{ establecimiento.direccion.direccion }}
        @if (establecimiento.direccion.latitud || establecimiento.direccion.longitud) {
          <small class="text-gray-500 dark:text-gray-400">
            {{ establecimiento.direccion.latitud || '-' }}, {{ establecimiento.direccion.longitud || '-' }}
          </small>
        }
      </div>
    } @else {
      <span class="text-gray-400 dark:text-gray-500">-</span>
    }
  </ng-template>

  <ng-template appTableCell="zona" let-establecimiento>
    @if (establecimiento.zona) {
      <div class="flex flex-col">
        {{ establecimiento.zona.nombre }}
        <small class="text-gray-500 dark:text-gray-400">{{ establecimiento.zona.direccion_completa }}</small>
      </div>
    } @else {
      <span class="text-gray-400 dark:text-gray-500">-</span>
    }
  </ng-template>

  <ng-template appTableCell="km" let-establecimiento>
    @if (establecimiento.km !== null) {
      {{ establecimiento.km }}
    } @else {
      <span class="text-gray-400 dark:text-gray-500">-</span>
    }
  </ng-template>
</app-data-table>

<app-pagination
  [currentPage]="currentPage"
  [lastPage]="lastPage"
  [perPage]="perPage"
  [total]="total"
  (pageChange)="onPageChange($event)"
  (perPageChange)="onPerPageChange($event)"
/>
